export const customStyles = {
	table: {
		style: {
			borderRadius: '5px',
			overflow: 'hidden',
			border: '1px solid #e0e0e0',
		},
	},
	pagination: {
		style: {
			borderTop: 'none',
			padding: '16px',
		},
	},
	headRow: {
		style: {
			backgroundColor: '#fafafa',
			borderBottom: '1px solid #e0e0e0',
		},
	},
	headCells: {
		style: {
			borderRight: '1px solid #eee',
			fontWeight: 'bold',
			fontSize: '14px',
		},
	},
	rows: {
		style: {
			borderBottom: '1px solid #eee',
		},
	},
	cells: {
		style: {
			borderRight: '1px solid #eee',
		},
	},
};